import { Config } from "./Configuration";

const development: Config = {
    language: "en",
    sentry: {
        dsn: "https://fe1d6ce862a14d7383186305f40475a9@o399431.ingest.sentry.io/6414661",
        environment: "development",
        tracesSampleRate: 1.0,
    },
};

export default development;
